import OkC from "shared/util/OkcApi";

export function startValidation(data) {
	return OkC.post("/oksms/validation/start", {
		api: 1,
		data,
	});
}

export function completeValidation(data) {
	return OkC.post("/oksms/validation/complete", {
		api: 1,
		data,
	});
}



// WEBPACK FOOTER //
// ./src/apps/phone_verification/util/web.js